import React, {Component} from 'react';
import {Row,Col,Modal,FormControl,Button,ButtonToolbar,Form,FormGroup,ControlLabel} from 'react-bootstrap'
import Select,{Creatable} from 'react-select'
import WorkdocStore from '../../stores/WorkdocStore'
import PODocStore from '../../stores/PODocStore'
import { Radio } from 'react-icheck'
import FontAwesome from 'react-fontawesome'
import ConfirmPopup from 'component/element/ConfirmPopup'
import CKAutocomplete from 'component/element/CKAutocomplete'

class SWTCustomerEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initItem()
  }

  componentDidMount() {
    
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!==this.props.show) {
      this.loadBankList()
      this.loadShopCategoryList()
    }
  }

  initItem(){
    return {shop_category_list:[],showSale:false,sales:[],valid:{name:false,title:false,tax_no:false,catSelect:false},showConfirm:false,provinceList:[],catOptions:[],isLoadingProvince:false,titleList:[],isLoadingTitle:false,itemcode:'',catSelect:{value:'',label:''},
    shop_id:undefined,customer_id:undefined,title:'',name:'',address:'',tax_no:'',driver_license_no:'',tel:'',province:'',postalcode:'',credit_day:'',branch:'',isBranch:false,house_no:'',village_no:'',street_address:'',
    sub_district:'',district:'',building_name:'',room_no:'',floor_no:'',soi:'',contact_name:'',contact_tel:'',isBank:false,bank_name:'',bank_branch:'',bank_number:'',shop_category:'',website:''}
  }

  loadBankList() {
    WorkdocStore.loadBankList((result)=>{
      let lists = result.data.map((item,index)=>{
        return item
      })
      this.setState({bankList:lists})
    })
  }

  loadShopCategoryList() {
    WorkdocStore.loadShopCategoryList((result)=>{
      let shop_category_list = []
      shop_category_list = result.data.map((item,index)=>{
        return {label:item.Name,value:item.Value}
      })
      this.setState({shop_category_list:shop_category_list})
    })
  }

  loadItemcode(item,catOptions=[]){
    catOptions = catOptions.map((citem,cindex)=>{
      if(citem.name!==undefined)
        return {label:citem.name,value:citem.id}
      else
        return citem
    })
    if(item!==null){
      let {provinceList,titleList} = this.state
      this.setState(Object.assign(this.initItem(),{provinceList:provinceList,titleList:titleList,catOptions:catOptions},item))

      //Load customer
      
      if(item.customer_id!==undefined && item.customer_id!==''){        
        this.loadCustomer(item,item.customer_id)
      }else if(item.shop_id!==undefined && item.shop_id!==''){
        this.loadSupplier(item,item.shop_id)
      }        
    }else{
      let {provinceList,titleList} = this.state
      if(provinceList.length<=1){
        provinceList = []
      }
      if(titleList.length<=1){
        titleList = []
      }
      this.setState(Object.assign(this.initItem(),{provinceList:provinceList,titleList:titleList,catOptions:catOptions}));
    }
    
  }

  processData(item,result){
    let isBranch = false
    if(result.data.branch!==undefined&& result.data.branch!==''){
      isBranch  =true
    }
    let {provinceList,titleList} = this.state
    if(provinceList.length<=1){
      if(result.data.province!=='')
        provinceList =  [{label:result.data.province,value:result.data.province}]
      else
        provinceList = []
    }
    
    
    
    if(result.data.title!=='')                
      titleList =  [{label:result.data.title,value:result.data.title}]
    else
      titleList = []
    
    
    this.setState(Object.assign({isBranch:isBranch},result.data,{provinceList:provinceList,titleList:titleList}))
  }

  loadSupplier(item,shop_id){
    PODocStore.loadSupplier(shop_id, (result)=>{
      this.processData(item,result)
      if(result.category!==undefined){
        let catOptions = result.category.map((item,index)=>{
          return {label:item.name,value:item.id}
        })
        this.setState({showSale:(result.data.contactlist.length>0?true:false),sales:result.data.contactlist,shop_id:shop_id,catOptions:catOptions,catSelect:this.getSelectOption(catOptions,result.data.shop_type)})
      }else{
        this.setState({sales:[],shop_id:shop_id})
      }
    },
    ()=>{

    })
  }

  loadCustomer(item,customer_id){
    
    WorkdocStore.loadCustomer(customer_id, (result)=>{
      this.processData(item,result)
      if(result.category!==undefined){
        let catOptions = result.category.map((item,index)=>{
          return {label:item.name,value:item.id}
        })
        this.setState({customer_id:customer_id,catOptions:catOptions,catSelect:this.getSelectOption(catOptions,item.customer_type)})
      }else{
        this.setState({customer_id:customer_id,catSelect:this.getSelectOption(this.state.catOptions,item.customer_type)})
      }
    },
    ()=>{

    })
  }

  newEmptyRow(number) {
    return new Array(number).fill(null).map((item, index) => {
      return {name:'',description:'',tel:'',tel_ext:'',line_id:'',remark:''}
    })
  }

  checkForceDelete(sales) {
    let _sales = []
    sales.forEach((item,index)=>{
      if (!item.force_delete)
        _sales.push(item)
    })
    return _sales
  }

  getSelectOption(catOptions,categoryId){
    let catSelect = {value:'',label:''}
    catOptions.map((item,index)=>{
      if(item.value===categoryId){
        catSelect = item
      }
    })

    return catSelect

  }

  onTextChange(field,e){
    let state = this.state
    
    state[field] = e.target.value
    
    this.setState(state)
  }

  onTextSelect(field,e){
    let state = this.state
    
    state[field] = e
    
    this.setState(state)
  }

  onSelectChange(value){
    if(value==null){
      value = {value:'',label:''}
    }
    this.setState({catSelect:value})
  }

  onProvinceChange(e){
    let province = ''
    if(e!==null){
      province = e.value
    }
    this.setState({province:province})
  } 

  onProvinceOpen(){
    let {provinceList} = this.state
    if(provinceList.length<=1){
      this.setState({isLoadingProvince:true})
      WorkdocStore.loadProvince((result)=>{
        let provinceList = result.data.map((item,index)=>{
          return {label:item.name,value:item.name}
        })
        this.setState({isLoadingProvince:false,provinceList:provinceList})
      },(error)=>{

      })
    }
  }

  onTitleChange(e){
    let title = ''
    if(e!==null){
      title = e.value
    }
    this.setState({title:title})
  } 

  onTitleOpen(){
    let {titleList,title} = this.state
    if(titleList.length<=1){
      this.setState({isLoadingTitle:true})
      WorkdocStore.loadTitle((result)=>{
        let foundIt = false
        let titleList = result.data.map((item,index)=>{
          if(title===item.Name){
            foundIt = true
          }
          return {label:item.Name,value:item.Value}
        })
        if(!foundIt && title!=='')
          titleList.push({label:title,value:title})
        this.setState({isLoadingTitle:false,titleList:titleList})
      },(error)=>{

      })
    }
  }

  onSaveClick(){
    let {accountEditView} = this.props
    let {website,shop_category,sales,valid,catSelect,customer_id,shop_id,title,name,address,tax_no,driver_license_no,tel,province,postalcode,credit_day,branch,house_no,village_no,street_address,sub_district,district,building_name,room_no,floor_no,soi,contact_name,contact_tel,isBank,bank_name,bank_branch,bank_number} = this.state

    valid = {name:false,title:false,tax_no:false,catSelect:false}
    this.setState({valid:valid})

    if (catSelect.value=='') {
      valid.catSelect = true
      this.setState({valid:valid})
      return false
    }

    if (tax_no=='') {
      valid.tax_no = true
      this.setState({valid:valid})
      return false
    }

    if (title=='') {
      valid.title = true
      this.setState({valid:valid})
      return false
    }

    if (name=='') {
      valid.name = true
      this.setState({valid:valid})
      return false
    }

    let postData = {shop_id:shop_id,customer_id:customer_id,cat_id:catSelect.value,title:title,name:name,
      address:address,tax_no:tax_no,driver_license_no:driver_license_no,tel:tel,province:province,postalcode:postalcode,
      credit_day:credit_day,branch:branch,house_no:house_no,village_no:village_no,shop_category:shop_category,website:website,
      street_address:street_address,sub_district:sub_district,district:district,building_name:building_name,
      room_no:room_no,floor_no:floor_no,soi:soi,contact_name:contact_name,contact_tel:contact_tel,isBank:isBank,
      bank_name:bank_name,bank_branch:bank_branch,bank_number:bank_number,account_edit_view:accountEditView,contactlist:sales}

    if(this.props.onSaveClick!==undefined){
      valid = {name:false,title:false,tax_no:false,catSelect:false}
      this.setState({valid:valid})
      this.props.onSaveClick(postData,()=>{
        this.props.onSearchAfterSubmit(postData)
        this.props.onHide()  
      });
    }
  }

  onBankClick() {
    this.setState({isBank:true})   
  }

  onBankChange(e) {
    let bank_name = ''
    if(e!==null){
      bank_name = e.value
    }
    this.setState({bank_name:bank_name})
  }

  onDelClick(){
    this.setState({showConfirm:true})
  }

  onConfirmDelete() {
    if(this.props.onDelClick!==undefined){
      this.props.onDelClick(this.state,(result)=>{
        if(this.props.onAfterDelete!==undefined)
          this.props.onAfterDelete()

        this.props.onHide()
        this.setState({showConfirm:false})
      },(fail)=>{
        this.setState({showConfirm:false})
      })
    }
  }

  onBranchChange(e) {
    let {isBranch} = this.state
    isBranch = !isBranch
    this.setState({isBranch:isBranch,branch:''})
  }

  onRowAdd(number) {
    let {sales} = this.state
    sales = sales.concat(this.newEmptyRow(number))
    this.setState({sales:sales})
  }

  onSalesChange(index,field,e) {
    let {sales} = this.state
    sales[index][field] = e.target.value
    this.setState({sales:sales})
  }

  onSalesClick() {
    this.setState({showSale:true})
  }

  onSalesDelClick(index) {
    let {sales} = this.state
    if (sales[index].shop_contact_id!==''&&typeof sales[index].shop_contact_id!=='undefined')
      sales[index] = Object.assign({force_delete:true},sales[index])
    else
      sales.splice(index,1)
    this.setState({sales:sales})
  }

  renderSaleRowData() {
    let {sales} = this.state
    if (sales.length===0||this.checkForceDelete(sales).length===0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
      let i = -1
      return(
        sales.map((item,index)=>{
          if (!item.force_delete) {
            i++
            return(
              <tr key={index}>
                <td className='text-center'>{i+1}</td>
                <td className='text-center'><FormControl value={item.name} onChange={this.onSalesChange.bind(this,index,'name')} /></td>
                <td className='text-center'><FormControl value={item.description} onChange={this.onSalesChange.bind(this,index,'description')} /></td>
                <td className='text-center'><FormControl value={item.tel} onChange={this.onSalesChange.bind(this,index,'tel')} /></td>
                <td className='text-center'><FormControl value={item.tel_ext} onChange={this.onSalesChange.bind(this,index,'tel_ext')} /></td>
                <td className='text-center'><FormControl value={item.line_id} onChange={this.onSalesChange.bind(this,index,'line_id')} /></td>
                <td className='text-center'><FormControl value={item.remark} onChange={this.onSalesChange.bind(this,index,'remark')} /></td>
                <td className='text-center'>
                  <Button bsStyle='danger' onClick={this.onSalesDelClick.bind(this,index)}><FontAwesome name='trash' /></Button>
                </td>
              </tr>
            )
          } else { return(<tr style={{display:'none'}} key={index}><td colSpan={8}>DELETE</td></tr>) }  
        })
      )
    }
  }

  renderTableSale() {
    let {sales} = this.state
    let _sales = this.checkForceDelete(sales)
    return(
      <Row>
        <Col md={12}>
          <div className='table-responsive' style={{height:(_sales.length>4?'319px':''),overflowY:'auto'}}>
            <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
              <thead>
                <tr>
                  <th style={{width:'50px'}} className='text-center'>ลำดับ</th>
                  <th style={{width:'150px'}} className='text-center'>ชื่อ</th>
                  <th style={{width:'200px'}} className='text-center'>รับผิดชอบ</th>
                  <th style={{width:'100px'}} className='text-center'>เบอร์มือถือ</th>
                  <th style={{width:'80px'}} className='text-center'>เบอร์ต่อ</th>
                  <th style={{width:'120px'}} className='text-center'>ID LINE</th>
                  <th style={{width:'90px'}} className='text-center'>หมายเหตุ</th>
                  <th style={{width:'50px'}} className='text-center'>ลบ ?</th>
                </tr>
              </thead>
              <tbody>
                {this.renderSaleRowData()}
              </tbody>
            </table>
          </div>
          <div style={{marginTop:'10px'}}>
            {this.renderNewItemButton()}
          </div>
        </Col>
      </Row>    
    )
  }

  renderNewItemButton() {
    return(
      <ButtonToolbar>
        <Button className='bg-olive' onClick={this.onRowAdd.bind(this, 1)}><FontAwesome name='plus' />&nbsp;เพิ่มรายการ</Button>
      </ButtonToolbar>    
    )
  }

  renderForm(){
    let {website,shop_category,showSale,valid,contact_name,contact_tel,address,catOptions,catSelect,name,title,provinceList,isLoadingProvince,titleList,isLoadingTitle,tax_no,driver_license_no,tel,province,postalcode,credit_day,branch,isBranch,house_no,village_no,street_address,sub_district,district,building_name,room_no,floor_no,soi,isBank,bank_name,bank_branch,bank_number,bankList} = this.state
    let {accountEditView,showProvince} = this.props
    return(
      <div>
        <Row>
          <Col md={4}>
            <Form horizontal>
              <FormGroup validationState={valid.catSelect?'error':null}>
                <Col componentClass={ControlLabel} sm={5}>
                  หมวดหมู่ <span className='color-red'>*</span>
                </Col>
                <Col sm={7}>
                  <Select value={catSelect} 
                    placeholder={'เลือกหมวดหมู่'} 
                    options={catOptions} 
                    onChange={this.onSelectChange.bind(this)}
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={valid.tax_no?'error':null}>
                <Col componentClass={ControlLabel} sm={5}>
                  เลขประจำตัวผู้เสียภาษี <span className='color-red'>*</span>
                </Col>
                <Col sm={7}>
                  <FormControl value={tax_no} onChange={this.onTextChange.bind(this,'tax_no')}/>
                </Col>
              </FormGroup>  
              <FormGroup validationState={valid.title?'error':null}>
                <Col componentClass={ControlLabel} sm={5}>
                  คำนำหน้า <span className='color-red'>*</span>
                </Col>
                <Col sm={7}>
                  <Creatable
                    promptTextCreator={(label)=>{ return 'ใส่คำนำหน้า... '+label }}
                    placeholder={'...คำนำหน้า...'}
                    loadingPlaceholder={'กำลังดึงข้อมูล....'}
                    isLoading={isLoadingTitle}                
                    value={title}
                    onOpen={this.onTitleOpen.bind(this)}
                    onChange={this.onTitleChange.bind(this)}
                    options={titleList}
                  />               
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  ชื่ออาคาร/หมู่บ้าน
                </Col>
                <Col sm={7}>
                  <FormControl value={building_name} onChange={this.onTextChange.bind(this,'building_name')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  ตรอก/ซอย
                </Col>
                <Col sm={7}>
                  <FormControl value={soi} onChange={this.onTextChange.bind(this,'soi')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  อำเภอ/เขต
                </Col>
                <Col sm={7}>
                <FormControl value={district} onChange={this.onTextChange.bind(this,'district')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView!=='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  ที่อยู่
                </Col>
                <Col sm={7}>
                  <FormControl componentClass="textarea" value={address} onChange={this.onTextChange.bind(this,'address')} rows={5} />
                </Col>
              </FormGroup>
            </Form>
          </Col>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  เครดิตการค้า (วัน)
                </Col>
                <Col sm={8}>
                  <FormControl  value={credit_day} onChange={this.onTextChange.bind(this,'credit_day')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:((catSelect.value=='PERSON' && this.props.isCustomer)?'':'none')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  เลขที่ใบขับขี่
                </Col>
                <Col sm={8}>
                  <FormControl value={driver_license_no} onChange={this.onTextChange.bind(this,'driver_license_no')}/>
                </Col>
              </FormGroup> 
              <FormGroup style={{display:((catSelect.value=='PERSON' && !this.props.isCustomer)?'':'none')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  <br/>
                </Col>
                <Col sm={8}>
                  <br/>
                </Col>
              </FormGroup> 
              <FormGroup style={{display:(catSelect.value==='COMPANY'?'':'none')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  สำนักงานใหญ่/สาขา
                </Col>
                <Col sm={7} style={{display:'inline-flex'}}>
                  <div>
                    <Radio                
                      onChange={this.onBranchChange.bind(this)}
                      checked={!isBranch}
                      radioClass="iradio_square-blue"
                      increaseArea="20%"
                      label=" สำนักงานใหญ่"
                    />
                  </div>
                  &nbsp;
                  <div>
                    <Radio                
                      onChange={this.onBranchChange.bind(this)}
                      checked={isBranch}
                      radioClass="iradio_square-blue"
                      increaseArea="20%"
                      label=" สาขา"
                    />
                  </div>
                </Col>
              </FormGroup>
              <FormGroup validationState={valid.name?'error':null}>
                <Col componentClass={ControlLabel} sm={4}>
                  ชื่อ{this.props.editTitle} <span className='color-red'>*</span>
                </Col>
                <Col sm={8}>
                  <FormControl value={name} onChange={this.onTextChange.bind(this,'name')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  ห้องเลขที่
                </Col>
                <Col sm={3}>
                  <FormControl value={room_no} onChange={this.onTextChange.bind(this,'room_no')}/>
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  ชั้นที่
                </Col>
                <Col sm={3}>
                  <FormControl value={floor_no} onChange={this.onTextChange.bind(this,'floor_no')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView=='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  ถนน
                </Col>
                <Col sm={8}>
                  <FormControl value={street_address} onChange={this.onTextChange.bind(this,'street_address')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:((showProvince||accountEditView==='full_view')?'':'none')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  จังหวัด
                </Col>
                <Col sm={8}>
                  <Select
                    placeholder={'...ค้นหาจังหวัด...'}
                    loadingPlaceholder={'กำลังดึงข้อมูล....'}
                    isLoading={isLoadingProvince}                
                    value={province}
                    onOpen={this.onProvinceOpen.bind(this)}
                    onChange={this.onProvinceChange.bind(this)}
                    options={provinceList}
                  />              
                </Col>
              </FormGroup>  
            </Form>  
          </Col>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  ประเภท
                </Col>
                <Col sm={8}>
                  <CKAutocomplete
                    top='-35px'
                    items={this.state.shop_category_list}
                    value={shop_category===null||shop_category===undefined?'':shop_category}
                    onChange={this.onTextChange.bind(this,'shop_category')}
                    onSelect={this.onTextSelect.bind(this,'shop_category')}
                    shouldItemRender={null}
                  />
                </Col>
              </FormGroup>
              <FormGroup style={{display:(catSelect.value==='COMPANY'?'':'none')}}>
                <Col componentClass={ControlLabel} sm={3}>
                  สาขา
                </Col>
                <Col sm={8}>
                  <FormControl value={branch} onChange={this.onTextChange.bind(this,'branch')} disabled={!isBranch} />
                </Col>
              </FormGroup>
              <FormGroup style={{display:(catSelect.value!=='COMPANY'?'':'none')}}>
                <Col componentClass={ControlLabel} sm={3}>
                  <br/>
                </Col>
                <Col sm={8}>
                  <br/>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  เบอร์โทร
                </Col>
                <Col sm={8}>
                  <FormControl  value={tel} onChange={this.onTextChange.bind(this,'tel')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={3}>
                  เลขที่
                </Col>
                <Col sm={3}>
                  <FormControl value={house_no} onChange={this.onTextChange.bind(this,'house_no')}/>
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  หมู่ที่
                </Col>
                <Col sm={3}>
                  <FormControl value={village_no} onChange={this.onTextChange.bind(this,'village_no')}/>
                </Col>
              </FormGroup>
              <FormGroup style={{display:(accountEditView==='short_view'?'none':'')}}>
                <Col componentClass={ControlLabel} sm={3}>
                  ตำบล/แขวง
                </Col>
                <Col sm={8}>
                  <FormControl value={sub_district} onChange={this.onTextChange.bind(this,'sub_district')}/>
                </Col>
              </FormGroup>  
              <FormGroup style={{display:((showProvince||accountEditView==='full_view')?'':'none')}}>
                <Col componentClass={ControlLabel} sm={3}>
                  รหัสไปรษณีย์
                </Col>
                <Col sm={8} >
                  <FormControl value={postalcode} onChange={this.onTextChange.bind(this,'postalcode')}/>
                </Col>
              </FormGroup>  
            </Form>
          </Col>
        </Row> 
        <Row>
          <Col md={8}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2} style={{width:'20.8%'}}>
                  Website
                </Col>
                <Col sm={9} style={{width:'79.2%'}}>
                  <FormControl value={website} onChange={this.onTextChange.bind(this,'website')} />
                </Col>
              </FormGroup>
            </Form>  
          </Col>  
        </Row>
        <Row>
          <Col md={4}>
            <Form horizontal>
              <FormGroup style={{display:(catSelect.value==='COMPANY'?'':'none')}}>
                <Col componentClass={ControlLabel} sm={5}>
                  ชื่อผู้ติดต่อ
                </Col>
                <Col sm={7}>
                  <FormControl value={contact_name} onChange={this.onTextChange.bind(this,'contact_name')}/>
                </Col>
              </FormGroup>
            </Form>
          </Col>
          <Col md={4}>
            <Form horizontal>
              <FormGroup style={{display:(catSelect.value==='COMPANY'?'':'none')}}>
                <Col componentClass={ControlLabel} sm={4}>
                  เบอร์โทรผู้ติดต่อ
                </Col>
                <Col sm={8}>
                  <FormControl value={contact_tel} onChange={this.onTextChange.bind(this,'contact_tel')}/>
                </Col>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{display:(catSelect.value==='COMPANY'?'':'none')}}>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col onClick={this.onSalesClick.bind(this)} componentClass={ControlLabel} sm={5} style={{color:'#337ab7',cursor:'pointer'}}>
                  <FontAwesome name='plus' /> เพิ่มผู้ติดต่อ (Sale)
                </Col>  
              </FormGroup>
            </Form>    
          </Col>
          {showSale?
          <Col md={8} className='text-right'>
            <Form horizontal>
              <FormGroup>
                <Col onClick={()=>{this.setState({showSale:false})}} componentClass={ControlLabel} sm={12} style={{cursor:'pointer'}}>
                  <FontAwesome name='close' /> ปิด
                </Col>  
              </FormGroup>
            </Form>    
          </Col>
          :''}
        </Row>
        {showSale?this.renderTableSale():''}
        {showSale?<br />:''}
        <Row>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col onClick={this.onBankClick.bind(this)} componentClass={ControlLabel} sm={5} style={{color:'#337ab7',cursor:'pointer'}}>
                  <FontAwesome name='plus' /> เพิ่มบัญชีธนาคาร
                </Col>  
              </FormGroup>
            </Form>    
          </Col>
          {isBank?
          <Col md={8} className='text-right'>
            <Form horizontal>
              <FormGroup>
                <Col onClick={()=>{this.setState({isBank:false})}} componentClass={ControlLabel} sm={12} style={{cursor:'pointer'}}>
                  <FontAwesome name='close' /> ปิด
                </Col>  
              </FormGroup>
            </Form>    
          </Col>
          :''}
        </Row>
        <Row style={{display:(isBank?'':'none')}}>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={5}>
                  ธนาคาร
                </Col>  
                <Col sm={7}>
                  <Select
                    placeholder={'เลือกธนาคาร'} 
                    options={bankList===undefined?[]:bankList}
                    value={bank_name}
                    onChange={this.onBankChange.bind(this)}
                  />
                </Col>
              </FormGroup>
            </Form>    
          </Col>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  สาขา
                </Col>  
                <Col sm={8}>
                  <FormControl value={bank_branch} onChange={this.onTextChange.bind(this,'bank_branch')}/>
                </Col>
              </FormGroup>
            </Form>    
          </Col>
          <Col md={4}>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={3}>
                  เลขที่บัญชี
                </Col>  
                <Col sm={8}>
                  <FormControl value={bank_number} onChange={this.onTextChange.bind(this,'bank_number')}/>
                </Col>
              </FormGroup>
            </Form>    
          </Col>
        </Row>         
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {customer_id} = this.state

    let title = ''
    if(customer_id===''){
      title = 'เพิ่ม'+this.props.editTitle+'ในระบบ'
    }else{
      title = 'แก้ไขรายละเอียด'+this.props.editTitle
    }
    return (
      <div>
        <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="fullwidth-dialog">
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{overflowY:'auto',maxHeight:'90vh',height:'82.3vh'}}>
            {this.renderForm()}
          </Modal.Body>
          <Modal.Footer>
            <ButtonToolbar className='pull-right'>
            <Button bsStyle={'danger'}  onClick={this.onDelClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบข้อมูล</Button>
            <Button bsStyle={'primary'}  onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึกข้อมูล</Button>
            <Button onClick={this.props.onHide}><FontAwesome name='close' />&nbsp;ยกเลิก</Button>
            </ButtonToolbar>
          </Modal.Footer>
        </Modal>
        <ConfirmPopup
          show={this.state.showConfirm}
          onConfirm={this.onConfirmDelete.bind(this)}
          onHide={()=>this.setState({showConfirm:false})}
          message={'คุณแน่ใจที่จะลบข้อมูล ? เอกสารบางอย่างอาจจะเชื่อมโยงกับข้อมูลนี้ กรุณาตรวจสอบก่อนการลบ'}
          confirmTitle={'ยืนยัน ขอลบข้อมูล'}
        />
      </div>  
    )
  }
}

SWTCustomerEditModal.defaultProps = {
  editTitle: 'ลูกค้า',
  accountEditView: 'short_view',
  showProvince:true,
  isCustomer:true
}

export default SWTCustomerEditModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTCustomerEditModal.js